import projects from '../data/projects.json';

// Get project details by ID (useful for routing)
export const getProjectById = (projectId) => {
  return projects.find(p => p.id === projectId);
};

// Get project by Airtable ID (useful for cross-references)
export const getProjectByAirtableId = (airtableId) => {
  return projects.find(p => p.airtableId === airtableId);
};

// Format a compact reference to a project
export const formatProjectReference = (airtableId) => {
  const project = getProjectByAirtableId(airtableId);
  return project?.abbreviation || airtableId;
};

// Get the latest public project by highest order (excluding non-portfolio pages)
export const getLatestPublicProject = () => {
  const excludedIds = new Set(['about', 'terms', 'privacy', 'shipping', 'legal-notice']);
  const publicPortfolioProjects = projects
    .filter(p => p.status === 'Public' && !excludedIds.has(p.id));

  if (publicPortfolioProjects.length === 0) {
    return null;
  }

  const sortedDesc = [...publicPortfolioProjects].sort((a, b) => (b.order || 0) - (a.order || 0));
  return sortedDesc[0];
};

export const getLatestPublicProjectId = () => getLatestPublicProject()?.id || null;
